<template>
  <div>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="1" hide-arrow style="margin: 20px 0 0 0;border:0">
        <FormTitle :titleText="$t('Social_Relationships')" /><!-- 社会关系 -->
        <div slot="content" style="margin-top: 40px;">
          <Table border :loading="loading" :columns="columns1" :data="data">
            <template slot-scope="{ row, index }" slot="name">
              <Input
                type="textarea"
                :autosize="true"
                v-model="row.name"
                disabled
                @on-change="targetItemChange(row, index, 'name')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="relation">
              <Input
                type="textarea"
                :autosize="true"
                v-model="row.relation"
                disabled
                @on-change="targetItemChange(row, index, 'relation')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="address1">
              <Input
                type="textarea"
                :autosize="true"
                v-model="row.address1"
                disabled
                @on-change="targetItemChange(row, index, 'address1')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="mobile">
              <Input
                type="textarea"
                :autosize="true"
                v-model="row.mobile"
                disabled
                @on-change="targetItemChange(row, index, 'mobile')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="emergencycontact">
              <Checkbox
                v-model="row.emergencycontact"
                disabled
                @on-change="targetItemChange(row, index, 'emergencycontact')"
              ></Checkbox>
            </template>
            <!--<template slot="action" slot-scope="{ row, index }">
              <Button
                type="warning"
                disabled
                size="small"
                style="margin-right: 8px"
                @click="save(row, index)"
                > 保存 {{ $t("Save") }}</Button
              >
              <Button
                type="error"
                disabled
                size="small"
                @click="deleteItem(row, index)"
                > 删除 {{ $t("Delete") }}</Button
              >
            </template>-->
          </Table>
          <div  v-if="id==''">
            <span style="color: red;">{{$t('EmpFilesComment')}}</span>
        </div> 
          <div
            style="margin:20px 0 0 0; display:flex; justify-content: flex-end;"
          >
            <Page :total="total" @on-change="pageChange" />
            <!--<div style="margin-left:15px" v-if="id == ''">
              <Button @click="addItem"> 新增 {{ $t("Add") }}</Button>
               <Button  @click="save">保存</Button> -->
            <!-- </div> -->
          </div>
        </div>
      </Panel>
    </Collapse>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  data() {
    return {
      formItem: {},
      list: [],
      value: [1],
      date: new DateUtil(),
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      acData: [],
      id: "",
      serialnumber: "",
      columns1: []
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          slot: "name",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Relationship") /* 关系 */,
          slot: "relation",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Address") /* 地址一 */,
          slot: "address1",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Mobile") /* 手机 */,
          slot: "mobile",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Emergency_Contacts") /* 紧急联系人 */,
          slot: "emergencycontact",
          align: "center",
          minWidth: 120
        },
        // {
        //   title: this.$t("Action") /* 操作 */,
        //   slot: "action",
        //   align: "center",
        //   minWidth: 120
        // }
      ];
    },
    columns2() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          slot: "name",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Relationship") /* 关系 */,
          slot: "relation",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Address") /* 地址一 */,
          slot: "address1",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Mobile") /* 手机 */,
          slot: "mobile",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Emergency_Contacts") /* 紧急联系人 */,
          slot: "emergencycontact",
          align: "center",
          minWidth: 120
        }
      ];
    }
  },
  methods: {
    getData(val) {
      this.loading = true;
      val
        ? (this.serialnumber = val)
        : (this.serialnumber = JSON.parse(
            sessionStorage.getItem("userInfo")
          ).serialnumber);
      axios
        .post("/socialRelations/getSocialRelations", {
          ...this.pageInfo,
          serialnumber: this.serialnumber
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            if (val) {
              this.data = this.data.filter(item => {
                return item.emergencycontact == 1;
              });
              this.columns1 = this.columns2;
            } else {
              this.columns1 = this.columns;
            }
            this.acData = JSON.parse(JSON.stringify(res.data));
            this.data.forEach((el, index) => {
              el.emergencycontact = !!+el.emergencycontact;
            });
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    addItem() {
      this.data.push({
        name: "",
        relation: "",
        address1: "",
        mobile: "",
        emergencycontact: "",
        serialnumber: this.serialnumber
      });
    },
    save(item, index) {
      if (!item.emergencycontact) {
        var flag = false;
        this.acData.map(acDataItem => {
          if (
            acDataItem.emergencycontact == "1" &&
            item.autoid != acDataItem.autoid
          ) {
            flag = true;
          }
        });
        if (!flag) {
          this.$Message.info(this.$t("请至少选择一名紧急联系人"));
          return;
        }
      } else {
        if (!item.name || !item.mobile) {
          this.$Message.info(this.$t("请填写紧急联系人的姓名和手机"));
          return;
        }
      }

      this.$Modal.confirm({
        title: this.$t("修改操作具有法律效力"),
        onOk: () => {
          let obj = JSON.parse(JSON.stringify(item));
          obj.emergencycontact
            ? (obj.emergencycontact = "1")
            : (obj.emergencycontact = "0");
          axios
            .post("/socialRelations/insertSocialRelations", obj)
            .then(res => {
              if (res) {
                this.$Message.success(this.$t("Save_Successful"));
                this.getData();
              }
            });
        }
      });
    },
    deleteItem(item, index) {
      if (item.emergencycontact) {
        var flag = false;
        this.acData.map(acDataItem => {
          if (
            acDataItem.emergencycontact == "1" &&
            item.autoid != acDataItem.autoid
          ) {
            flag = true;
          }
        });
        if (!flag) {
          this.$Message.info(this.$t("请至少保留一名紧急联系人"));
          return;
        }
      }
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          if (item.autoid) {
            axios
              .post("/socialRelations/deleteSocialRelations", {
                autoid: item.autoid,
                serialnumber: this.serialnumber
              })
              .then(res => {
                if (res) {
                  this.$Message.success("删除成功");
                  this.getData();
                }
              });
          } else {
            this.data.splice(index, 1);
          }
        }
      });
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data[index], key, row[`${key}`]);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(this.serialnumber);
    }
  }
};
</script>

<style lang="less" scoped>
.btnfooter {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/SocialRelations.vue